var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"logo-wrapper",attrs:{"href":_vm.$routes.HOME}},[(_vm.logo && _vm.logo.logo.url)?_c('img',{staticClass:"logo",attrs:{"src":_vm.logo.logo.url}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }